import React from "react";
import style from "./stylesheets/Logo.module.scss";
import EngineeringLogo from "../resources/yale_engineering_white.png";

const Logo = () => {
    return (
        <img src={EngineeringLogo} alt="Yale Engineering" className={style.logo} />
    );
}

export default Logo;
